import { render, staticRenderFns } from "./GoinView.vue?vue&type=template&id=37eee486&scoped=true"
import script from "./GoinView.vue?vue&type=script&lang=js"
export * from "./GoinView.vue?vue&type=script&lang=js"
import style0 from "../assets/fazhan.css?vue&type=style&index=0&id=37eee486&prod&scoped=true&lang=css&external"
import style1 from "./GoinView.vue?vue&type=style&index=1&id=37eee486&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37eee486",
  null
  
)

export default component.exports